import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'react/api/actions';
import TaskSchedulerContent from './TaskSchedulerContent';
import { CustomProvider } from 'react/utils/renderUtils';

const { taskScheduler } = actions;

class TaskScheduler extends Component {

  componentWillUnmount() {
    const { clearTaskSchedulerStateAction } = this.props;
    clearTaskSchedulerStateAction();
  }

  componentDidUpdate(prevProps) {
    const { hideTaskSchedulerAlertAction, className } = this.props;
    if (className.includes('is-active') !== prevProps.className.includes('is-active')) {
      hideTaskSchedulerAlertAction();
    }
  }

  renderHelpButton = () => {
    const help = new Monet.UI.Help('TaskScheduler', Monet.I18n.getResourcesByKey('TaskScheduler.title'));
    return (
      <a className='MonetUIHelp MonetUIHelpLink' onClick={ () => help.logIn() }></a>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <CustomProvider>
        <div id="TaskScheduler" className={ className }>
          <div className="task-scheduler-container">
            <div id="taskSchedulerHeader">
              { this.renderHelpButton() }
            </div>
            <TaskSchedulerContent />
          </div>
        </div>
      </CustomProvider>
    );
  };
}

TaskScheduler.defaultProps = {
  className: '',
};

TaskScheduler.propTypes = {
  clearTaskSchedulerStateAction: PropTypes.func.isRequired,
  hideTaskSchedulerAlertAction: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const mapDispatchToProps = {
  clearTaskSchedulerStateAction: taskScheduler.actionCreators.clearTaskSchedulerState,
  hideTaskSchedulerAlertAction: taskScheduler.actionCreators.hideTaskSchedulerAlert,
};

export default connect(null, mapDispatchToProps)(TaskScheduler);
